import React from 'react';

// Probador de alertas: dispara solo la alerta del overlay (?streamGadgets=rewardsAlertStream),
// sin escribir en el chat ni tocar la base de datos. Las de recompensas y eventos se prueban
// desde sus pestañas (Eventos) o canjeando de verdad, porque tambien entran en el panel.
const ALERTS = [
    { label: 'Follow (Twitch)', body: { type: 'follow', platform: 'twitch' } },
    { label: 'Follow (YouTube)', body: { type: 'follow', platform: 'youtube' } },
    { label: 'Follow (Kick)', body: { type: 'follow', platform: 'kick' } },
    { label: 'Follow (TikTok)', body: { type: 'follow', platform: 'tiktok' } },
    { label: 'Follow (Starvios)', body: { type: 'follow', platform: 'starvios' } },
    { label: 'Comando recompensa', body: { type: 'code' } },
    { label: 'Drop (Twitch)', body: { type: 'drop', platform: 'twitch' } },
    { label: 'Drop (YouTube)', body: { type: 'drop', platform: 'youtube' } },
];

const AdminAlertas = () => {
    const [status, setStatus] = React.useState('');

    const fire = async (alert) => {
        setStatus('');
        try {
            const res = await fetch('/api/adminLogin?action=testAlert', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(alert.body)
            });
            const data = await res.json();
            setStatus(data && data.success ? 'Alerta «' + alert.label + '» enviada al overlay.' : ((data && data.error) || 'No se pudo enviar'));
        } catch (err) {
            setStatus('No se pudo enviar');
        }
    };

    return (
        <div className='heroes formOver'>
            <h1>Probar alertas</h1>
            <p style={{ fontSize: 13, color: '#ccc' }}>
                Salen en el browser source <span className='userLink'>?streamGadgets=rewardsAlertStream</span>,
                con el directo apagado y sin escribir en ningún chat. La de follow sale cada vez con una mascota al azar y el icono de su plataforma.
            </p>
            <div className='navTops heroes unselectable'>
                {ALERTS.map(alert => <div key={alert.label} onClick={() => fire(alert)}>{alert.label}</div>)}
            </div>
            {status ? <p role='status'>{status}</p> : null}
        </div>
    );
};

export default AdminAlertas;
